/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scope: NonNullable<unknown> }} Task_Catalog_RemoveInputs */

const en_task_catalog_remove = /** @type {(inputs: Task_Catalog_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove from ${i?.scope}`)
};

const pt_br2_task_catalog_remove = /** @type {(inputs: Task_Catalog_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover de ${i?.scope}`)
};

/**
* | output |
* | --- |
* | "Remove from {scope}" |
*
* @param {Task_Catalog_RemoveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_remove = /** @type {((inputs: Task_Catalog_RemoveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_RemoveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_remove(inputs)
	return pt_br2_task_catalog_remove(inputs)
});